import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Actions } from 'src/app/models/actions';
import { DynamicTableInterface } from 'src/app/models/interface/dynamicTable';
import { TenantState } from 'src/app/store/state/tenant.state';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil, tap, filter, distinctUntilChanged, map, take } from 'rxjs/operators';

import { diagnosticProviders } from 'src/app/models/diagnosticProvider';
import * as _ from 'lodash';
import { DiagnosticProviderService } from 'src/app/shared/services/diagnostic-provider.service';
import { DiagnosticProviders } from 'src/app/models/constant/providers.enum';
import { FeatureFlagService } from 'src/app/shared/services/feature-flag.service';
import { FeatureFlagEnum } from 'src/app/shared/feature-flags.enum';
import { VehicleService } from '../vehicle/service/vehicle.service';

import { Vehicle } from 'src/app/models/vehicle';
import { GroupPartial } from 'src/app/models/groupPartial';
import { AssetFaultService } from 'src/app/services/asset-fault.service';
import { AssetFault } from 'src/app/models/assetFault';
import { DynamicTableModule } from 'src/app/dynamic-table/dynamic-table.module';
import { FaultDescritpionService } from 'src/app/services/fault-descritpion.service';
import { TableButton } from 'src/app/models/tableButton';
import { AssetFaultDisplay } from 'src/app/models/assetFaultDisplay';
import { DynamicTableDisplayColumn } from 'src/app/models/dynamicTableDisplayColumn';
import { FaultFixNotSupportedComponent, FaultFixNotSupportedInput } from 'src/app/shared/fault-fix-not-supported/fault-fix-not-supported.component';
import { DrawerService } from 'src/app/shared/drawer/drawer.service';
import { AssetFaultDetailComponent } from '../asset-fault-detail/asset-fault-detail.component';
import { SpaRoutingService } from 'src/app/shared/services/spa.routing.service';

@Component({
    selector: 'app-asset-fault',
    imports: [DynamicTableModule],
    templateUrl: './asset-fault.component.html',
    styleUrl: './asset-fault.component.css'
})

export class AssetFaultComponent  implements OnInit, DynamicTableInterface {
  @SelectSnapshot(TenantState.getCurrentTenantExternalId) getCurrentTenantExternalId: string;
  private destroy$ = new Subject();
  @Input() vehicleGroups: GroupPartial[] = [];

  Actions: typeof Actions = Actions;
  loading = true;
  title = '@vehicleFaults';
  vehicleFaults: AssetFaultDisplay[];
  dataSource = new MatTableDataSource<any>();
  matSortActive = '';
  baseSort = '"faultDateUtc": -1';

  private currentSort = `{${this.baseSort}}`;
  private currentFilter = '{}';
  private currentOffset = 0;
  private currentLimit = 10;

  isJSFilter = true;
  includeSelect = false;

  searchString = `{$or: [
    {"protocol": /|replaceText|/i},
    {"sourceAddressDescription": /|replaceText|/i},
    {"faultCodeDescription": /|replaceText|/i},
    {"failureCodeDescription": /|replaceText|/i},
    {"description": /|replaceText|/i}
  ]}`;

  gridDisplayColumns = [
    {
      display: '@faultToFix',
      property: 'fixButton',
      type: 'button',
      noSort: true
    },
    {
      display: '@protocol',
      property: 'protocol',
      type: 'noTruncateText'
    },
    {
      display: '@controller',
      property: 'controller',
      type: 'noTruncateText'
    },
    {
      display: '@fault',
      property: 'faultCode',
      type: 'noTruncateText',
    },
    {
      display: '@fmi',
      property: 'failureMode',
      type: 'noTruncateText'
    },
    {
      display: '@dtcDetails',
      property: 'dtcDescription',
      type: 'noTruncateText',
    },
    {
      display: '@description',
      property: 'description',
      type: 'noTruncateText',
      hidden: true
    },
    {
      display: '@state',
      property: 'faultState',
      type: 'noTruncateText'
    },
    {
      display: '@timesLogged',
      property: 'instanceCount',
      type: 'number'
    },
    {
      display: '@occurrenceCount',
      property: 'occurrenceCount',
      type: 'number'
    },
    {
      display: '@firstLogged',
      property: 'firstDateUtc',
      type: 'date'
    },
    {
      display: '@lastActive',
      property: 'lastActiveDateUtc',
      type: 'date'
    },
    {
      display: '@lastLogged',
      property: 'latestDateUtc',
      type: 'date',
      hidden: true
    },

  ] as DynamicTableDisplayColumn[];
  tableFunctions = [
    {
      display: '@showAllColumns',
      action: 'show',
      icon: 'fa fa-eye'
    },
  ];
  length: number;

  diagnosticProviderDefinitions = diagnosticProviders;
  tenantId: string = '';
  hasDiagnosticProvider: boolean;
  diagnosticProviderStrings: string[] = [];
  defaultDiagnositcProvider: string;
  isMitchelActive = false;
  isJaltestActive = false;
  vin: string = '';
  vehicle: Vehicle;
  viewDiagnosticArticle = false;

  constructor(
    private readonly diagnosticProviderService: DiagnosticProviderService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private vehicleService: VehicleService,
    private featureFlagService: FeatureFlagService,
    private translate: TranslateService,
    private assetFaultService: AssetFaultService,
    private faultDescritpionService: FaultDescritpionService,
    private drawerService: DrawerService,
    private spaRoutingService: SpaRoutingService) {
  }

  ngOnInit(): void {
    this.featureFlagService.getFeatureFlagValue(FeatureFlagEnum.DiagnosticArticles).subscribe(res => { this.viewDiagnosticArticle = res; });
    this.tenantId = this.getCurrentTenantExternalId;
    this.vin = this.activeRoute.snapshot.params.id;

      combineLatest([
        this.faultDescritpionService.getAlertTypes$,
        this.diagnosticProviderService.findDiagnosticProvider(this.tenantId),
        this.assetFaultService.getAssetFaultState(this.vin),
        this.assetFaultService.getFaultStates()])
      .pipe(
        tap(([_, diagnostic, faults, states]: [any, string[], AssetFault[], any]) => {
          this.diagnosticProviderStrings = diagnostic;
          if (diagnostic?.length > 0) {
            this.defaultDiagnositcProvider = diagnostic[0];
          }
          const normalizedDiagnostics = diagnostic.map(p => p.toLowerCase());
          this.isMitchelActive = normalizedDiagnostics.includes(DiagnosticProviders.Mitchell.toLowerCase());
          this.isJaltestActive = normalizedDiagnostics.includes(DiagnosticProviders.Jaltest.toLowerCase());
          this.hasDiagnosticProvider = this.isMitchelActive || this.isJaltestActive;
        }),
        map(([_, diagnostic, faults, states]: [any, string[], AssetFault[], any]) => [faults, states])
      )
      .subscribe(([faults, states]) => {
        if (faults) {
          this.getDescriptions(faults, states);
          this.getData(this.currentOffset, this.currentLimit, this.currentFilter, this.currentSort);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  getData(offset: number, limit: number, filter: string, sort: string): void {
    if (this.vehicleFaults) {
      const currentFilter = JSON.parse(filter);

      let filterProtocol = '';
      let filterSourceAddressDescription = '';
      let filterFaultCodeDescription = '';
      let filterFailureCodeDescription = '';
      let filterDescription = '';
      let filterFaultType = '';

      if (currentFilter.protocol) {
        filterProtocol = currentFilter.protocol.toLowerCase();
      }
      if (currentFilter.sourceAddressDescription) {
        filterSourceAddressDescription = currentFilter.sourceAddressDescription.toLowerCase();
      }
      if (currentFilter.faultCodeDescription) {
        filterFaultCodeDescription = currentFilter.faultCodeDescription.toLowerCase();
      }
      if (currentFilter.failureCodeDescription) {
        filterFailureCodeDescription = currentFilter.failureCodeDescription.toLowerCase();
      }
      if (currentFilter.description) {
        filterDescription = currentFilter.description.toLowerCase();
      }
      if (currentFilter.faultType) {
        filterFaultType = currentFilter.faultType.toLowerCase();
      }

      this.vehicleFaults.forEach(fault => {
        fault.fixButton = this.getTableButton(fault);
      });

      const filterFaults = this.vehicleFaults.filter(faultInfo => {
        return faultInfo.protocol.toLowerCase().includes(filterProtocol)
          && faultInfo.controllerDescription.toLowerCase().includes(filterSourceAddressDescription)
          && faultInfo.faultCodeDescription.toLowerCase().includes(filterFaultCodeDescription)
          && faultInfo.failureModeDescription.toLowerCase().includes(filterFailureCodeDescription)
          && faultInfo.description.toLowerCase().includes(filterDescription)
          && faultInfo.faultType.toLowerCase().includes(filterFaultType);
      });

      const currentSort = JSON.parse(sort);

      const sortKey = Object.keys(currentSort) ? Object.keys(currentSort)[0] : "";
      const sortDirection = currentSort[sortKey];
      filterFaults.sort(this.dynamicSort(sortKey, sortDirection));
      const endIdx = offset + limit;
      const newDataSource = filterFaults.slice(this.currentOffset, endIdx);
      this.dataSource = new MatTableDataSource<any>(newDataSource);
      const length = filterFaults.length;
      this.length = length;
      this.loading = false;
    }
  }

  private doesProviderSupportProtocol(providerString: string, protocol: string): boolean {
    if(!providerString) return false;
    const provider = this.diagnosticProviderDefinitions.find(x => x.name === providerString?.toLowerCase());
    return provider.supportedProtocols.includes(protocol);
  }

  private doesProviderSupportVehicle(providerString: string): boolean {
    if(!providerString) return false;
    const provider = this.diagnosticProviderDefinitions.find(x => x.name === providerString?.toLowerCase());
    return _.filter(this.vehicleGroups, g => _.includes(g['values'][provider.groupKey], 'True')).length > 0
  }

  private dynamicSort(property, sortOrder): (a: any, b: any) => number {
    if (property === "dtc") {
      return (a, b): number => {
        const result = (a["controller"] < b["controller"]) ? -1 : (a["controller"] > b["controller"]) ? 1 :
          ((a["faultCode"] < b["faultCode"]) ? -1 : (a["faultCode"] > b["faultCode"]) ? 1 :
            (a["failureMode"] < b["failureMode"]) ? -1 : (a["failureMode"] > b["failureMode"]) ? 1 : 0);
        return result * sortOrder;
      };
    }
    return (a, b): number => {
      const result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
      return result * sortOrder;
    };
  }

  pageChangedEvent(event): void {
    const pageIndex = event.pageIndex;
    const pageSize = event.pageSize;
    this.currentLimit = pageSize;
    const previousSize = pageSize * pageIndex;
    this.currentOffset = previousSize;
    this.getData(
      this.currentOffset,
      this.currentLimit,
      this.currentFilter,
      this.currentSort
    );
  }

  sortDataEvent(sort: string): void {
    this.currentSort = sort;
    this.currentOffset = 0;
    this.getData(
      this.currentOffset,
      this.currentLimit,
      this.currentFilter,
      this.currentSort);
  }

  filterChanged(filterList: string): void {
    this.currentFilter = filterList;
    this.currentOffset = 0;
    this.getData(
      this.currentOffset,
      this.currentLimit,
      this.currentFilter,
      this.currentSort);
  }

  refreshDataEvent(event: any): void {
    const pageIndex = event.pageIndex;
    const pageSize = event.pageSize;
    this.currentLimit = pageSize;
    const previousSize = pageSize * pageIndex;
    this.currentOffset = previousSize;
    this.currentFilter = event.filter;
    this.currentSort = event.sortString;
    this.getData(
      this.currentOffset,
      this.currentLimit,
      this.currentFilter,
      this.currentSort
    );

  }

  selectRowEvent(event: any): void {
    
  }

  processFunction(event: any): void {
    switch (event.action) {
      case 'page':
        this.pageChangedEvent(event);
        break;
      case 'filter':
        this.filterChanged(event.filter);
        break;
      case 'sort':
        this.sortDataEvent(event.sort);
        break;
      case 'refresh':
        this.refreshDataEvent(event);
        break;
      case 'navigate':
        const drawer = this.drawerService.open(
          AssetFaultDetailComponent,
          [
            { input: 'assetFault', value: event.row },
            { input: 'vin', value: this.vin }],
          {
            resizable: true,
            overlayClose: true
          });
        drawer.close.pipe(take(1)).subscribe(() => {
          this.drawerService.close();
        });
        break;
      case 'show':
            this.toggleShowColumns(event.showAllColumns);
            break;
    }
  }

  private getDescriptions(faults: AssetFault[], states: { [key: number]: string }): void {
    this.vehicleFaults = faults.map((f: AssetFault) =>
    ({
      protocol: f.protocol,
      controller: f.controller,
      failureMode: f.failureMode,
      faultCode: f.faultCode,
      faultCodeId: f.faultCodeId,
      faultType: f.faultType,
      faultState: states[f.faultState],
      occurrenceCount: f.occurrenceCount,
      instanceCount: f.instanceCount,
      description: f.description,
      firstDateUtc: f.firstDateTimeUtc,
      latestDateUtc: f.latestDateTimeUtc,
      lastActiveDateUtc: f.lastActiveDateTimeUtc
    } as AssetFaultDisplay));


    this.vehicleFaults.map((faultData: AssetFaultDisplay) => {
      faultData.faultCodeDescription = faultData.faultCode.toString();
      faultData.failureModeDescription = faultData.failureMode.toString();
      faultData.controllerDescription = faultData.controller.toString();

      if (faultData.faultType != "") {
        faultData.controllerDescription = faultData.faultType + ": " + faultData.controllerDescription;
      }

      const description = this.faultDescritpionService.getDescriptions(
        faultData.protocol,
        faultData.controller,
        faultData.faultCode,
        faultData.failureMode,
        faultData.faultType,
        faultData.faultCodeId);

      if (description.faultCodeDescription) {
        faultData.faultCodeDescription += ` - ${description.faultCodeDescription}`;
      }

      if (description.failureModeDescription) {
        faultData.failureModeDescription += ` - ${description.failureModeDescription}`;
      }

      if (description.controllerDescription) {
        faultData.controllerDescription += ` - ${description.controllerDescription}`;
      }

      faultData.dtcDescription = [description.controllerDescription, description.faultCodeDescription, description.failureModeDescription, faultData.description].filter(s => s).join(', ');

    });

    this.vehicleFaults = this.vehicleFaults.sort((a, b) => a.latestDateUtc < b.latestDateUtc ? 1 : -1);
  }

  private setSubject(faultCode: string, failureCode: string): string {
    if(faultCode.indexOf('-') > 0) {
      return faultCode.substring(faultCode.indexOf('-') + 2);
    }
    if(failureCode.indexOf('-') > 0) {
      return failureCode.substring(failureCode.indexOf('-') + 2);
    }
    return '';
  }

  private getTableButton(vehiclefault: AssetFaultDisplay): TableButton {
    
    const vehicleSupport = this.doesProviderSupportVehicle(this.defaultDiagnositcProvider);
    const protocolSupport = this.doesProviderSupportProtocol(this.defaultDiagnositcProvider, vehiclefault.protocol);
    
    const shouldDisplay =
      this.hasDiagnosticProvider && vehicleSupport && protocolSupport;

    const fixButton: TableButton = {
      display: shouldDisplay,
      clickAction: () => this.faultProviderButtonClicked(vehiclefault),
      displayText: this.translate.instant('@faultProviderFixButtonDescription'),
      noButtonComponent: FaultFixNotSupportedComponent,
      noButtonComponentInputs: {provider: this.defaultDiagnositcProvider, supportedVehicle: vehicleSupport, supportedProtocol: protocolSupport} as FaultFixNotSupportedInput
    };

    return fixButton;
  }

  private faultProviderButtonClicked(vehicleFault: AssetFaultDisplay): void {
    if (vehicleFault !== undefined && this.hasDiagnosticProvider) {
      let navigationExtras: NavigationExtras;
      const vehFault = this.translate.instant('@vehicleFault');
      let subject = vehFault  + ' - ' + this.setSubject(vehicleFault.faultCodeDescription, vehicleFault.failureModeDescription);
      let vehicle = this.vehicleService.getVehicleByVin(this.vin);
      if(!vehicle) return;

      switch (this.defaultDiagnositcProvider.toLowerCase()) {
        case DiagnosticProviders.Jaltest:
          navigationExtras = {
            queryParams: {
              subject: subject,
              vehicleName: this.vin,
              diagnosticProvider: DiagnosticProviders.Jaltest,
              make: vehicle[0]?.make,
              model: vehicle[0]?.model,
              modelYear: vehicle[0]?.modelYear,
              engine: vehicle[0]?.buildConfiguration?.engineManufacturer + ' ' + vehicle[0]?.buildConfiguration?.engineModel,
              desc: vehicleFault.description,
              faultType: vehicleFault.faultType
            }
          };
          this.spaRoutingService.navigateToTriggeredAlert(
            this.vin,
            vehicleFault.protocol,
            vehicleFault.faultCode.toString(),
            vehicleFault.failureMode.toString(),
            vehicleFault.controller.toString(),
            navigationExtras);
          break;
        case DiagnosticProviders.Mitchell:
          navigationExtras = {
            queryParams: {
              subject: subject,
              vehicleName: this.vin,
              diagnosticProvider: DiagnosticProviders.Mitchell,
              faultType: vehicleFault.faultType
            }
          };
          if (this.viewDiagnosticArticle) {
            this.spaRoutingService.navigateToDiagnosticArticle(
              this.vin,
              vehicleFault.protocol,
              vehicleFault.controller.toString(),
              vehicleFault.faultCode.toString(),
              vehicleFault.failureMode.toString(),
              "us");
          } else {
            this.spaRoutingService.navigateToTriggeredAlert(
              this.vin,
              vehicleFault.protocol,
              vehicleFault.faultCode.toString(),
              vehicleFault.failureMode.toString(),
              vehicleFault.controller.toString(),
              navigationExtras);
          }
          break;
      }
    }
    else { alert('vehicleFault is undefined!'); }
  }

  private toggleShowColumns(showAllColumn: boolean): void {
    this.gridDisplayColumns.forEach(col => {
      if (showAllColumn) {
        if (col.hidden === true) {
          col.hidden = false;
        }
      }
      else {
        if (col.hidden === false) {
          col.hidden = true;
        }
      }
    });
  }
}

